"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8184,4552,163],{

/***/ 78184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ getExperiment; }
/* harmony export */ });
/* unused harmony export sleep */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82222);
/* harmony import */ var _codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);




var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getExperiment = function(param) {
    var experimentId = param.experimentId, _iteration = param.iteration, iteration = _iteration === void 0 ? 0 : _iteration;
    return new Promise(function(resolve) {
        // if darkMode is enabled, by cookie etc., use Variant1
        if (iteration >= 10) {
            resolve("0");
        } else {
            var ref, ref1, ref2;
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("getExperiment: ".concat(experimentId, " iteration: ").concat(iteration));
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("type of window google optimize: ".concat((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(window === null || window === void 0 ? void 0 : (ref = window.google_optimize) === null || ref === void 0 ? void 0 : ref.get)));
            var variant = window === null || window === void 0 ? void 0 : (ref1 = window.google_optimize) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.get) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, experimentId);
            if (!variant) {
                resolve("0");
            } else if (variant === "1" || variant === "0") {
                resolve(variant);
            } else {
                sleep(50 + 50 * iteration).then((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.t0 = resolve;
                                _ctx.next = 3;
                                return getExperiment({
                                    experimentId: experimentId
                                }, iteration + 1);
                            case 3:
                                _ctx.t1 = _ctx.sent;
                                (0, _ctx.t0)(_ctx.t1);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))).catch(_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU);
            }
        }
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getExperiment)));


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);